import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Do I need to install any code or tracking pixels?",
    a: "Just one line. You paste a single lightweight script tag on your landing pages — it takes under a minute and adds no visible load time. From there ClickShield scores every ad click in real time, and connecting your Google, Meta or Bing accounts lets us push blocks straight to your exclusion lists.",
  },
  {
    q: "How fast does blocking happen?",
    a: "Fraudulent IPs are scored in real time and pushed to your ad platform exclusion lists within seconds — typically before the same bad actor can click again.",
  },
  {
    q: "What counts as a fraudulent click?",
    a: "Bots, click farms, competitors clicking repeatedly, data-center/VPN/proxy traffic, and clicks from outside your target geography. Every click is scored across 100+ signals.",
  },
  {
    q: "Is there really no credit card required?",
    a: "Correct. Start your 14-day free trial instantly. You'll only be asked for payment if you decide to continue after the trial.",
  },
  {
    q: "Are you compliant with SOC2 and GDPR?",
    a: "Yes. ClickShield AI is SOC2 Type II audited and fully GDPR ready. We never store personally identifiable information beyond what's needed for fraud scoring.",
  },
];

export const FAQSection = () => {
  return (
    <section id="faq" className="relative py-24 lg:py-32 border-t border-white/5">
      <div className="max-w-3xl mx-auto px-6 lg:px-8">
        <div className="mb-12">
          <span className="font-mono text-xs tracking-widest uppercase text-cyan-neon">[07] Questions</span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight text-white mt-4">
            Frequently asked.
          </h2>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <Accordion type="single" collapsible className="space-y-3">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="rounded-xl border border-white/8 bg-[#0B101A] px-6 data-[state=open]:border-cyan-neon/30 transition-colors"
              >
                <AccordionTrigger data-testid={`faq-trigger-${i}`} className="text-left text-white hover:no-underline font-medium py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-400 font-light leading-relaxed pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};
